<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-form-item label="会员姓名" prop="name">
      <el-input v-model="ruleForm.name"></el-input>
    </el-form-item>

    <el-form-item label="手机号码" prop="mobile">
      <el-input
        v-model="ruleForm.mobile"
        οninput="value=value.replace(/[^\d]/g,'');if(value.length > 11)value = value.slice(0, 11)"
      ></el-input>
    </el-form-item>

    <el-form-item label="出生日期" prop="birth">
      <el-date-picker
        type="date"
        placeholder="出生日期"
        v-model="ruleForm.birth"
      ></el-date-picker>
    </el-form-item>

    <el-form-item label="性别" prop="sex">
      <el-radio-group v-model="ruleForm.sex">
        <el-radio label="0">男</el-radio>
        <el-radio label="1">女</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="职业" prop="job">
      <el-input v-model="ruleForm.job"></el-input>
    </el-form-item>

    <!-- <el-form-item label="邮箱" prop="email">
      <el-input v-model="ruleForm.email"></el-input>
    </el-form-item> -->

    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item label="所属地区" prop="address">
          <el-cascader
            size="large"
            :options="addoptions"
            v-model="addselectedOptions"
            @change="addhandleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="detail">
          <el-input placeholder="详细地址" v-model="detail"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="产品名称" prop="productname">
      <el-input v-model="ruleForm.productname"></el-input>
    </el-form-item>
    <el-form-item label="数量" prop="count">
      <el-input v-model="ruleForm.count" type="number"></el-input>
    </el-form-item>
    <el-form-item label="单价" prop="price">
      <el-input v-model="ruleForm.price"></el-input>
    </el-form-item>
    <el-form-item label="金额(积分)" prop="memberpoints">
      <el-input v-model="ruleForm.memberpoints"></el-input>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input type="textarea" v-model="ruleForm.remark"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('ruleForm')"
        >立即创建</el-button
      >
      <el-button @click="resetForm('ruleForm')">重置</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import API from "../../../api/frbasicapi/member";
import {
  validateEMail,
  validatePhone,
  validatetoFixedNew,
} from "../../../utils/validators";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode,
} from "element-china-area-data";
export default {
  data() {
    return {
      detail: "",
      ruleForm: {
        name: "",
        mobile: "",
        birth: "",
        sex: "0",
        job: "",
        email: "",
        address: "",
      },
      rules: {
        name: [{ required: true, message: "请输入会员姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone },
        ],
        birth: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        // email: [{ validator: validateEMail }],
        address: [
          { required: true, message: "请选择所属地区", trigger: "blur" },
        ],
        productname: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        count: [{ required: true, message: "请输入数量", trigger: "blur" }],
        price: [
          { required: true, message: "请输入单价", trigger: "blur" },
          { validator: validatetoFixedNew },
        ],
        memberpoints: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { validator: validatetoFixedNew },
        ],
      },
      addoptions: regionDataPlus,
      addselectedOptions: [],
    };
  },
  methods: {
    addhandleChange(value) {
      var province = "";
      var city = "";
      var country = "";
      if (value != null && value != "") {
        province = CodeToText[value[0]];
        if (value[1] != null && value[1] != "") {
          city = CodeToText[value[1]];
        }
        if (value[2] != null && value[2] != "") {
          country = CodeToText[value[2]];
        }
        this.ruleForm.address = province + "/" + city + "/" + country;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          this.loading = true;
          this.ruleForm.address = this.ruleForm.address + "/" + this.detail;
          API.add(this.ruleForm)
            .then(
              function (result) {
                that.loading = false;
                if (result) {
                  that.$message.success(result.message);
                  that.$router.push('/sys/frbasicmember/list');
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>